// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"66096e61","5789":"08d0a81b","8974":"58a35938"}[chunkId] + ".chunk.css";
};